import { restServer } from "@app-utils/restServer";
import { AuthenticationResult } from "@enfusion-ui/types";
import queryString from "query-string";

type GenerateSecureAPITokenOptions = {
  adminuser?: string;
  adminpassword?: string;
  twoFactorToken?: string;
};

export async function systematicAuthenticate(
  username: string,
  password: string,
  restApiUrl: string
) {
  try {
    const response = await restServer<AuthenticationResult>(
      "/auth/authentication/authenticate",
      restApiUrl,
      {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Authorization: `Basic ${btoa(`${username}:${password}`)}`,
        },
        body: {},
      }
    );
    return typeof response === "string"
      ? (JSON.parse(response) as AuthenticationResult)
      : response;
  } catch (err) {
    console.error("authenticate error", err);
    throw new Error("Unauthorized");
  }
}
export async function systematicGenerateSecureAPIToken(
  username: string,
  password: string,
  options: GenerateSecureAPITokenOptions = {},
  restApiUrl: string
) {
  try {
    return restServer<string>(
      queryString.stringifyUrl({
        url: "/auth/authentication/generateSecureAPIToken",
        query: {
          adminuser: !!options.adminuser ? options.adminuser : undefined,
          adminpassword: !!options.adminpassword
            ? options.adminpassword
            : undefined,
        },
      }),
      restApiUrl,
      {
        method: "GET",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Authorization: `Basic ${btoa(`${username}:${password}`)}`,
        },
        // credentials: "include",
      }
    );
  } catch (err) {
    console.error("generateSecureAPIToken error", err);
    throw new Error("Unauthorized");
  }
}

export async function systematicGenerateTwoFactorToken(
  username: string,
  password: string,
  restApiUrl: string
) {
  try {
    return restServer<string>(
      "/auth/authentication/generateTwoFactorToken",
      restApiUrl,
      {
        method: "GET",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Authorization: `Basic ${btoa(`${username}:${password}`)}`,
        },
        // credentials: "include",
      }
    );
  } catch (err) {
    console.error("generateTwoFactorToken error", err);
    throw new Error("Two-factor code could not be generated");
  }
}

export async function systematicCheckTwoFactorToken(
  username: string,
  password: string,
  token: string, // This is the 2fa code the user enters
  cryptoToken: string, // This is the token string returned by generateTwoFactorToken
  restApiUrl: string
) {
  const url = queryString.stringifyUrl({
    url: "/auth/authentication/checkTwoFactorToken",
    query: { token, cryptoToken },
  });
  try {
    const res = await restServer<Record<string, unknown>>(url, restApiUrl, {
      method: "GET",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Authorization: `Basic ${btoa(`${username}:${password}`)}`,
      },
      // credentials: "include",
    });
    if (!res) throw new Error("empty response");
    return res;
  } catch (err) {
    console.error("checkTwoFactorToken error", err);
    throw new Error("Two-factor code could not be verified");
  }
}
